import React from "react";
import { Navigate } from "react-router-dom";
import { routes } from "./helpers/constants";
import { authRoutes, mainRoutes, otherRoutes } from "./helpers/AllRoutes";
import AuthLayout from "./Layouts/AuthLayout";
import MainLayout from "./Layouts/MainLayout";
import Page404 from "./pages/Page404";

const getRoutes = (user) => {
  // Simple logic based on your user data structure
  const needs2FAVerification = user && user.twofa_enabled;
  const needs2FASetup = user && !user.twofa_enabled;

  return [
    {
      path: routes.homePage,
      // Show auth layout if: no user OR needs 2FA verification OR needs 2FA setup
      element:
        !user || needs2FAVerification || needs2FASetup ? (
          <AuthLayout />
        ) : (
          <Navigate to={routes.dashboard} />
        ),
      children: authRoutes,
    },
    {
      path: routes.homePage,
      // Only show main layout if user exists and 2FA is handled
      // This condition should theoretically never be true with current logic, but kept for safety
      element: user ? <MainLayout /> : <Navigate to={routes.login} />,
      children: mainRoutes,
    },
    {
      path: "",
      element: !user ? <Navigate to={routes.login} /> : <Page404 />,
      children: otherRoutes,
    },
  ];
};

export default getRoutes;
